export const TOOLTIP_DATE_FORMAT = 'dd MMM yyyy';
